<template>
	<div>
		<div class="container">
		  <div class="textTitle">【放心飞】是飞游云为您提供的租赁附加服务。</div>
		  <div class="textContent">购买了【放心飞】后，在租期内，因产品主体损坏而产生的（维修费＋误工费＋维修运费），由飞游云进行承担；产品主体损坏而产生的配件更换费用不在保险范围内。
		  </div>
		  <div class="textTitle">服务说明</div>
		  <div class="textContent">1）订单逾期，【放心飞】自动作废；</div>
		  <div class="textContent">2）误工费为因商品损坏而无法进行后续租赁的费用，根据送修官方的具体时间来核算;未购买保险需按照当前的租赁金额和送修时间进行赔付；</div>
		  <div class="textContent">3）飞游云有权选择品牌方或正规有资质的第三方维修商对产品进行鉴定、维修，最终以飞游云出具的官方报价单为准。
		  </div>
		  <div class="textTitle">【放心飞】注意事项</div>
		  <div class="textContent">1）快递签收后须开箱检查，如机器问题或配件缺失应立即和客服联系解决。未及时反应情况则视为机器和配件完好；{{n}}2）产品在物流期间损坏产生的维修费用，不在【放心飞】保障范围内；{{n}}3）产品送修后，经官方或第三方维修商鉴定，无维修价值或者产品报废，则【放心飞】不可用，用户需按照市场价全额赔付；{{n}}4）机身有明显进沙、划痕、磨损、外壳凹陷的情况，将视为飞机主体损坏，会送与大疆官方进行维修；{{n}}5）因进水、浸液导致的产品损坏、报废以及相关配件在租赁期间丢失、被盗，不在【放心飞】保障范围内；{{n}}6）产品在租赁期间未经飞游云允许，进行过维修、拆机、刷机、改变操作系统等，造成设备无法正常使用、需维修、报废的，不在【放心飞】保障范围内；{{n}}7）擅自更换设备主体、配件，不在【放心飞】保障范围内；{{n}}8）续租需在租期内与工作人员取得联系并说明情况，逾期超过三天且无法取得正常联系（微信，电话），平台有权扣除其押金并追究后续法律责任；
		  </div>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				n:'\n'
			}
		},
		methods: {
			
		}
	}
</script>

<style>
.container {
  padding: 12px;
}
.textTitle {
  width: 100%;
  padding-left: 10px;
  position: relative;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
}
.textTitle::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #1956EC;
  transform: translateY(-50%);
}
.textContent {
  white-space: pre-wrap;
  margin-bottom: 17px;
  font-size: 13px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/serviceIntroduce.vue